import { apiClient } from "@/shared/api/client"

/** Окна, которые понимает API. null значит «за всё время». */
export const ANALYTICS_PERIODS = [7, 30, 90, 365] as const
export type AnalyticsPeriod = (typeof ANALYTICS_PERIODS)[number] | null

export interface Period {
	days: number | null
	from: string | null
	step: "day" | "week"
}

export interface AudienceAnalytics {
	period: Period
	totals: {
		users: number
		newUsers: number
		readers: number
		dau: number
		wau: number
		mau: number
		stickiness: number | null
		activation: number | null
	}
	/** Все аккаунты по Telegram и членству в канале клуба на последней ежедневной проверке. */
	membership: {
		/** Все участники канала по Telegram; null, если Telegram не ответил. */
		channelTotal: number | null
		inChannel: number
		notInChannel: number
		withoutTelegram: number
		checkedAt: string | null
	}
	series: Array<{ date: string; registrations: number; firstReads: number }>
	sources: Array<{ source: string | null; users: number }>
}

export interface ContentPostRow {
	id: string
	title: string | null
	viewers: number
	views: number
	favorites: number
	completion: number | null
	returnRate: number
	favoriteRate: number
}

export interface ContentAnalytics {
	period: Period
	totals: {
		posts: number
		people: number
		viewers: number
		views: number | null
		favorites: number
		returnRate: number
		favoriteRate: number
		completion: number | null
	}
	series: Array<{ date: string; newReaders: number; favorites: number }>
	byNiche: Array<{
		id: string
		name: string
		posts: number
		viewers: number
		favorites: number
		viewersPerPost: number
		favoriteRate: number
		completion: number | null
	}>
	topPosts: ContentPostRow[]
	deadPosts: Array<{ id: string; title: string | null; viewers: number; createdAt: string }>
	publishing: {
		live: { telegram: number; tma: number; mobile: number }
		drafts: number
		scheduled: number
		created: number
		sentToChannel: number
	}
}

const params = (days: AnalyticsPeriod) => (days ? { days } : {})

export const getAudienceAnalytics = async (days: AnalyticsPeriod) =>
	(await apiClient.get<AudienceAnalytics>("/admin/analytics/audience", { params: params(days) })).data

export const getContentAnalytics = async (days: AnalyticsPeriod) =>
	(await apiClient.get<ContentAnalytics>("/admin/analytics/content", { params: params(days) })).data
